import moment from 'moment';

import {
  getTotalPrice,
  getTotalRelatedItems
} from 'utils/book-accommodation-and-activity/totalPrice';
import {
  getAddOns,
  getMandatoryFees,
  getGuests,
  getGuestsActivity,
  getSchedule,
  getStartingDate
} from 'utils/book-accommodation-and-activity/prepareBookDataMethods';

const getPreparedBookAccommodationData = (
  accommodation,
  bookAccommodationForm,
  deletedRelatedActivities,
  isWidget,
  stripeToken,
  payPalOrderId
) => {
  const bookAccommodation = bookAccommodationForm.values;
  const adminPlatform = bookAccommodation.platform
    ? bookAccommodation.platform
    : 'Admin panel';
  const platform = isWidget ? 'Widget' : adminPlatform;
  const idObj = bookAccommodation.id ? { id: bookAccommodation.id } : {};
  const paymentIdObj = bookAccommodation.paymentId
    ? { id: bookAccommodation.paymentId }
    : {};

  let paymentType = 'CASH';
  if (stripeToken) paymentType = 'STRIPE';
  if (payPalOrderId) paymentType = 'PAYPAL';

  return {
    accommodationBooking: {
      ...idObj,
      accommodationId: accommodation.generalForm.id,
      guestFirstName: bookAccommodation.firstName,
      guestLastName: bookAccommodation.lastName,
      guestPhoneNumber: bookAccommodation.phone,
      guestEmail: bookAccommodation.email,
      platform: platform,
      fromDate: moment(bookAccommodation.dates.startDate).format('YYYY-MM-DD'),
      toDate: moment(bookAccommodation.dates.endDate).format('YYYY-MM-DD'),
      payment: {
        ...paymentIdObj,
        paymentType: paymentType,
        stripeToken: stripeToken,
        payPalOrderId: payPalOrderId,
        currency: bookAccommodation.currency,
        totalPrice: getTotalPrice(
          accommodation,
          bookAccommodation.dates,
          bookAccommodation.participants,
          bookAccommodation.addOns,
          bookAccommodation.mandatoryFees,
          bookAccommodation.activities,
          bookAccommodation.currency
        )
      },
      ...getAddOns(bookAccommodation, bookAccommodation.currency),
      ...getMandatoryFees(bookAccommodation, bookAccommodation.currency),
      ...getGuests(
        bookAccommodation,
        accommodation.pricesType,
        bookAccommodation.currency,
        true
      )
    },
    ..._getActivitiesBooking(bookAccommodation, isWidget),
    ..._getDeletedActivityBookings(deletedRelatedActivities)
  };
};

const _getDeletedActivityBookings = deletedRelatedActivities => {
  if (!deletedRelatedActivities || !deletedRelatedActivities.length) {
    return {};
  }

  return {
    deletedActivityBookings: deletedRelatedActivities
  };
};

const _getActivitiesBooking = (bookAccommodation, isWidget) => {
  const activities = bookAccommodation.activities.filter(
    item => (isWidget && item.isSelected) || !isWidget
  );

  if (!activities.length) return {};

  return {
    activitiesBookings: activities.map(item => {
      const idObj = item.id && !isWidget ? { id: item.id } : {};
      const paymentIdObj =
        item.paymentId && !isWidget ? { id: item.paymentId } : {};
      const activityId = isWidget ? item.id : item.activity;
      return {
        ...idObj,
        activityId: activityId,
        platform: isWidget ? 'Widget' : 'Admin panel',
        payment: {
          ...paymentIdObj,
          paymentType: 'CASH',
          currency: bookAccommodation.currency,
          totalPrice: getTotalRelatedItems([item], bookAccommodation.currency)
        },
        ...getStartingDate(item),
        ...getSchedule(item),
        ...getAddOns(item, bookAccommodation.currency),
        ...getMandatoryFees(item, bookAccommodation.currency),
        ...getGuestsActivity(item, item.pricesType, bookAccommodation.currency)
      };
    })
  };
};

export { getPreparedBookAccommodationData };
